import React from 'react';
import { Navigate } from 'react-router-dom';
import type { SchoolStudentFeatureKey } from '../../modules/platform/types/featureAccess';
import { useAuth } from '../../contexts/AuthContext';
import { useFeatureAccess } from '../../contexts/FeatureAccessContext';
import { ROUTES } from '../../utils/constants';
import { Spinner } from '../ui/Spinner';

interface StudentSchoolFeatureGateProps {
  featureKey: SchoolStudentFeatureKey;
  children: React.ReactNode;
}

/**
 * For student routes gated by school_feature_access. Redirects to dashboard when disabled or after load error.
 */
export const StudentSchoolFeatureGate: React.FC<StudentSchoolFeatureGateProps> = ({ featureKey, children }) => {
  const { isLmsLaunchSession } = useAuth();
  const { loading, isSchoolFeatureEnabled } = useFeatureAccess();

  if (isLmsLaunchSession && featureKey === 'ai_tutor') {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isSchoolFeatureEnabled(featureKey)) {
    return <Navigate to={ROUTES.STUDENT_DASHBOARD} replace />;
  }

  return <>{children}</>;
};
